import { __extends } from "tslib";
import ListState from './list-state';
var STATUS_SHOW = 'showRadio';

var ListRadio =
/** @class */
function (_super) {
  __extends(ListRadio, _super);

  function ListRadio() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  ListRadio.prototype.show = function () {
    var triggerInfo = this.getTriggerListInfo();

    if (triggerInfo === null || triggerInfo === void 0 ? void 0 : triggerInfo.item) {
      var list = triggerInfo.list,
          item = triggerInfo.item;
      list.setItemState(item, STATUS_SHOW, true);
    }
  };

  ListRadio.prototype.hide = function () {
    var triggerInfo = this.getTriggerListInfo();

    if (triggerInfo === null || triggerInfo === void 0 ? void 0 : triggerInfo.item) {
      var list = triggerInfo.list,
          item = triggerInfo.item;
      list.setItemState(item, STATUS_SHOW, false);
    }
  };

  return ListRadio;
}(ListState);

export default ListRadio;